'use strict';

class DocumentHistory {
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.history = [];

    this.load();
  }

  load() {
    if (this.number !== null && this.type) {
      this.$http.get(`/${this.type}/${this.number}/history`)
        .then((resp) => {
          this.history = resp.data;
        });
    }
  }
}

DocumentHistory.$inject = ['$http'];

const documentHistory = {
  bindings: {
    number: '<',
    type: '<',
    cash: '<'
  },
  controller: DocumentHistory,
  template: `
    <table class="documentHistory small">
      <thead>
        <tr>
          <th>Levert</th>
          <th>Dato</th>
          <th>Beskrivelse</th>
          <th>Adresse</th>
        </tr>
      </thead>
      <tbody>
      <tr ng-show="$ctrl.cash !== null && $ctrl.cash !== ''">
          <td><span><i class="fa fa-check" style="color: #0f4b1c;"></i></span></td>
          <td>{{ $ctrl.cash | dateFormat }}</td>
          <td class="nowrap">Kontantfaktura</td>
          <td></td>
      </tr>
        <tr ng-repeat="item in $ctrl.history track by $index" ng-class="item.status" ng-switch="item.status">
          <td ng-switch-when="DELIVERED" class="center-align"><span data-balloon="Mottak bekreftet"><i class="fa fa-check" style="color: #0f4b1c;"></i></span></td>
          <td ng-switch-when="NOT_DELIVERED" class="center-align"><span data-balloon="Avvist av mottager"><i class="fa fa-times" style="color: #970b0e;"></i></span></td>
          <td ng-switch-when="IN_PROGRESS" class="center-align"><span data-balloon="Forsendelse p&aring;g&aring;r"><i class="fa fa-refresh" style="color: #e5a631;"></i></span></td>
          <td ng-switch-when="SPAM" class="center-align"><span data-balloon="Markert som s&oslash;ppelpost av mottager"><i class="fa fa-trash" style="color: #000;"></i></span></td>
          <td>{{ item.date | dateFormat:true }}</td>
          <td class="nowrap">{{ item.description }}</td>
          <td>{{ item.recipientAddress }}</td>
        </tr>
      </tbody>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('documentHistory', documentHistory);
